var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c(
        "section",
        { staticClass: "form-section" },
        [
          !_vm.isSent
            ? _c("div", { staticClass: "registration" }, [
                _c("div", {
                  staticClass: "anchor",
                  attrs: { id: "form-anchor" },
                }),
                _c("div", { staticClass: "container" }, [
                  _c("h2", { staticClass: "registration__title" }, [
                    _vm._v("Регистрация"),
                  ]),
                  _c("div", { staticClass: "registration__wrapper" }, [
                    _c(
                      "form",
                      {
                        staticClass: "form",
                        attrs: { id: "page-form", method: "post" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.ajax()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "form__inner" }, [
                          _c("div", { staticClass: "form__wrapper" }, [
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Имя")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.name,
                                    expression: "participant.name",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "name",
                                  type: "text",
                                  placeholder: "Иван",
                                },
                                domProps: { value: _vm.participant.name },
                                on: {
                                  blur: [
                                    function ($event) {
                                      return _vm.checkEmpty(
                                        _vm.participant.name
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.participant,
                                      "name",
                                      $event.target.value.trim()
                                    )
                                  },
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Фамилия")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.surname,
                                    expression: "participant.surname",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "surname",
                                  type: "text",
                                  placeholder: "Иванов",
                                },
                                domProps: { value: _vm.participant.surname },
                                on: {
                                  blur: [
                                    function ($event) {
                                      return _vm.checkEmpty(
                                        _vm.participant.surname
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.participant,
                                      "surname",
                                      $event.target.value.trim()
                                    )
                                  },
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Телефон")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.phone,
                                    expression: "participant.phone",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "phone",
                                  type: "tel",
                                  placeholder: "+7 495 921 36 44",
                                },
                                domProps: { value: _vm.participant.phone },
                                on: {
                                  blur: [
                                    function ($event) {
                                      return _vm.checkEmpty(
                                        _vm.participant.phone
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.participant,
                                      "phone",
                                      $event.target.value.trim()
                                    )
                                  },
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Рабочая почта")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.email,
                                    expression: "participant.email",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "email",
                                  type: "email",
                                  placeholder: "example@mindbox.ru",
                                },
                                domProps: { value: _vm.participant.email },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.participant,
                                        "email",
                                        $event.target.value.trim()
                                      )
                                    },
                                    _vm.validateForm,
                                  ],
                                  blur: [
                                    function ($event) {
                                      return _vm.checkValueByRegEx(
                                        _vm.participant.email,
                                        _vm.regEmail
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Компания")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.company,
                                    expression: "participant.company",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "company",
                                  type: "text",
                                  placeholder: "Mindbox",
                                },
                                domProps: { value: _vm.participant.company },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.participant,
                                        "company",
                                        $event.target.value.trim()
                                      )
                                    },
                                    _vm.validateForm,
                                  ],
                                  blur: [
                                    function ($event) {
                                      return _vm.checkEmpty(
                                        _vm.participant.company
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Адрес сайта")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.site,
                                    expression: "participant.site",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "site",
                                  type: "text",
                                  placeholder: "mindbox.ru",
                                },
                                domProps: { value: _vm.participant.site },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.participant,
                                        "site",
                                        $event.target.value.trim()
                                      )
                                    },
                                    _vm.validateForm,
                                  ],
                                  blur: [
                                    function ($event) {
                                      return _vm.checkValueByRegEx(
                                        _vm.participant.site,
                                        _vm.regSite
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__input-description",
                                  attrs: {
                                    "data-error": " — Oбязательное поле",
                                  },
                                },
                                [_vm._v("Роль в компании")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.participant.role,
                                    expression: "participant.role",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  required: "required",
                                  name: "participant.role",
                                  type: "text",
                                  placeholder: "Директор",
                                },
                                domProps: { value: _vm.participant.role },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.participant,
                                        "role",
                                        $event.target.value.trim()
                                      )
                                    },
                                    _vm.validateForm,
                                  ],
                                  blur: [
                                    function ($event) {
                                      return _vm.checkEmpty(
                                        _vm.participant.role
                                      )
                                    },
                                    function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  ],
                                },
                              }),
                            ]),
                            _c("label", { staticClass: "form__input-label" }, [
                              _c(
                                "div",
                                { staticClass: "form__input-description" },
                                [_vm._v("Вопрос к СЕО (необязательно)")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.question,
                                    expression: "question",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form__input",
                                class: {},
                                attrs: {
                                  name: "question",
                                  type: "text",
                                  placeholder:
                                    "Задайте вопрос, который вас волнует",
                                },
                                domProps: { value: _vm.question },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.question = $event.target.value.trim()
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]),
                            _c("div", { staticClass: "form__submit-wrapper" }, [
                              _c("div", { staticClass: "form__submit-label" }, [
                                _c("input", {
                                  staticClass: "form__submit",
                                  class: _vm.isSending
                                    ? "form__submit--sending"
                                    : "",
                                  attrs: {
                                    type: "submit",
                                    value: "регистрация",
                                  },
                                }),
                              ]),
                              _vm._m(0),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "about" }, [
                      _c("div", { staticClass: "about__hr" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "6",
                              height: "2400",
                              viewBox: "0 0 6 2400",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M3 2400L3.0001 -3.0756e-05",
                                stroke: "black",
                                "stroke-width": "5",
                                "stroke-dasharray": "24 24",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "1140",
                              height: "4",
                              viewBox: "0 0 1140 4",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M0 2H1140",
                                stroke: "black",
                                "stroke-width": "3",
                                "stroke-dasharray": "24 24",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._m(1),
                      _c("p", { staticClass: "about__event" }, [
                        _vm._v("CEO Summit 2022"),
                      ]),
                      _c("p", { staticClass: "about__text" }, [
                        _vm._v(
                          "CEO соберутся в студии в центре Москвы, а зрители будут смотреть прямую трансляцию и задавать вопросы"
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.isSent
            ? _c("FormSuccess", {
                attrs: { participant: _vm.participant, question: _vm.question },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "form__agreement" }, [
      _vm._v("Регистрируясь, вы подтверждаете согласие на обработку "),
      _c(
        "a",
        {
          attrs: {
            href: "https://mindbox.ru/documents/policy/",
            target: "_blank",
          },
        },
        [_vm._v("персональных данных")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "about__wrapper" }, [
      _c("p", { staticClass: "about__date" }, [
        _vm._v("24 ноября "),
        _c("br"),
        _vm._v("15:00–17:00 "),
        _c("br"),
        _vm._v("online"),
      ]),
      _c("p", { staticClass: "about__free" }, [_vm._v("Вход свободный")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }